import { createFileRoute } from "@tanstack/react-router";
import { LearnArticlePage } from "#/features/learn/components/learn-article-page";

export const Route = createFileRoute("/ko/_app/learn/$slug")({
	component: KoLearnArticleRoute,
});

function KoLearnArticleRoute() {
	const { slug } = Route.useParams();
	return <LearnArticlePage slug={slug} />;
}
